import React, {useState, useEffect, useRef} from 'react';
import GetData from '../../../API/GetData';
import axios from 'axios';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Swal from "sweetalert2";
import { url } from '../../../Config';
import {Tooltip} from "@mui/material";
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import VisibilityIcon from '@mui/icons-material/Visibility';




export default function PrandRRhold(props) {

    const id = localStorage.getItem("userID");
    const [data, setdata] = useState([]);
    const [open, setOpen] = useState(false);
    const [message, setmessage] = useState();
    const [open2, setOpen2] = useState(false);
    const [message2, setmessage2] = useState();
    const [alertType, setAlertType] = useState("success");
    const [bool, setbool] = useState(false);
    const [status, setstatus] = useState('loading');
    const [searchTerm, setSearchTerm] = useState("");
    let a = 1;


     function DateFormat(params) {
          if (params == null) {
            return "-";
          } else {
            const date = new Date(params);
            const yyyy = date.getFullYear();
            const yy = yyyy.toString();
            const y = yy.slice(2, 4);
            let mm = date.toLocaleString("default", { month: "short" });
            let dd = date.getDate();
            if (dd < 10) dd = "0" + dd;
            return dd + "-" + mm + "-" + y;
          }
        }
    


     useEffect(() => {
        setstatus('loading');

        GetData.Outstandinglist().then((res) => {
        res = res.data.data;
        let arr = [];

        if(Number(id) == 19){
             for(let i in res){
                    if(res[i].hold_status == 'Entered'){
                        arr.push(res[i]);
                    }
                }
                setdata(arr);
                setstatus('loaded');
        }
        else{
            for(let i in res){
                if(res[i].user_id1 == Number(id)){
                    arr.push(res[i]);
                }
            }
            setdata(arr);
            setstatus('loaded');
        }

        });
    }, [bool]);


     let filteredOpinions = [];
        filteredOpinions = data.filter((value) => {
    
        if(searchTerm !== null){
            let Entity = [];
            if(value['Entity'] !== null){
            Entity = value['Entity'].toLowerCase().includes(searchTerm.toLowerCase());
            }
        
            return Entity;
        }
        
        else if(searchTerm == null){
            return data;
        }
        }
      );

      const prhold = async (event, recordid, opinion_id, reason, fromdate, fromtime, todate, totime, sub, load, btn)=>{

          event.preventDefault();
          sub.hidden = true;
          load.hidden = false;
          btn.disabled = true;


        const res = await axios.post(`${url}/api/holdform`,{
            'record_id': recordid,
            'opinion_id': opinion_id,
            'report': 'PR',
            'from_date' : fromdate,
            'to_date' : todate,
            'from_time' : fromtime,
            'to_time' : totime,
            'reason' : reason,
            'status' : 'Entered',
            'is_active' : 1,

        })

        const resp = res.data;
         if(resp.status == true){
              sub.hidden = false;
              load.hidden = true;
              window.location.reload();
          }
          else{
              btn.disabled = false;
              sub.hidden = false;
              setAlertType('error');
              setOpen(true);
              setmessage(resp.messages); 
          }



      }

      const rrhold = async (event, recordid, opinion_id, report, reason, fromdate, fromtime, todate, totime, sub, load, btn)=>{

            event.preventDefault();
            sub.hidden = true;
            load.hidden = false;
            btn.disabled = true;

            const res = await axios.post(`${url}/api/holdform`,{
                'record_id': recordid,
                'opinion_id': opinion_id,
                'report': report,
                'from_date' : fromdate,
                'to_date' : todate,
                'from_time' : fromtime,
                'to_time' : totime,
                'reason' : reason,
                'status' : 'Entered',
                'is_active' : 1,

            })

            const resp = res.data;

            if(resp.status == true){
                sub.hidden = false;
                load.hidden = true;
                window.location.reload();
            }
            else{
                btn.disabled = false;
                sub.hidden = false;
                load.hidden = true;
                setmessage(resp.messages); 
                setAlertType('error');
                setOpen(true);
            }

      }

      const approve = async (recordid, opinionid, approve, load)=>{

         Swal.fire({ title: 'Are you sure you want to Approve this request?', 
                    showDenyButton: false, showCancelButton: true, confirmButtonText: 'Approve'})
                    .then(async(result) => {
                      if (result.isConfirmed) {
                        
                        setOpen2(false);
                        approve.hidden = true;
                        load.hidden = false;

                        const res = await axios.post(`${url}/api/approveholdform`,{
                                    'record_id': recordid,
                                    'opinion_id': opinionid,
                            });

                        const resp = res.data;

                            if(resp.status == true){
                                approve.hidden = false;
                                load.hidden = true;
                                setmessage2(resp.message);
                                setAlertType('success');
                                setOpen2(true);
                                setbool(!bool);
                            }

                            else{
                                approve.hidden = false;
                                load.hidden = true;
                                setmessage2(resp.message);
                                setAlertType('error');
                                setOpen2(true);
                            }

                        }
                })       

      }

      const decline = async (recordid, opinionid)=>{

            Swal.fire({ title: 'Are you sure you want to Decline this request?', 
                    showDenyButton: false, showCancelButton: true, confirmButtonText: 'Decline'})
                    .then(async(result) => {
                      if (result.isConfirmed) {
                        setOpen2(false);
                        const res = await axios.post(`${url}/api/declineholdform`,{
                                    'record_id': recordid,
                                    'opinion_id': opinionid,
                            });

                            const resp = res.data;

                            if(resp.status == true){
                                setmessage2(resp.message);
                                setAlertType('success');
                                setOpen2(true);
                                setbool(!bool);
                            }

                            else{
                                setmessage2(resp.message);
                                setAlertType('error');
                                setOpen2(true);
                            }

                        }
                })

      }




  return (
    <div style={data.length == 0 ? {height: '90vh'} : Number(id) == 19 ? {height: '90vh'} : null}>
          <div className='fs-3 fw-bold text-center mt-2 mb-3' style={{color: "#000078"}}>
              PR and RR hold Form
          </div>
           {status == 'loaded' ?
           data.length > 0 ?
              <>
                <div className='col-9 mx-auto'>
                    <input className='form-control' placeholder='Search Opinion' onChange={(e)=>{setSearchTerm(e.target.value)}} />
                </div>
                <div className='col-10 mx-auto'>
                    <Box sx={{ width: '100%' }}>
                        <Collapse in={open2}>
                            <Alert
                            severity={alertType}
                            action={
                                <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setOpen2(false);
                                }}
                                >
                                <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                            sx={{ mb: 2 }}
                            >
                            {message2}
                            </Alert>
                        </Collapse>
                    </Box>
                </div>
                <div className='mt-3 card shadow col-11 mx-auto'>
                            <table className='table table-bordered border-dark table-striped table-hover'>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Opinion Name</th>
                                        {Number(id) == 19 && <th>Team Lead</th>}
                                        <th>Notification Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        filteredOpinions.map((value, index)=>{
                                            if(Number(id) == 19){
                                                return(
                                                    <>
                                                        <tr>
                                                            <td>{a++}</td>
                                                            <td>{value.Entity}</td>
                                                            {Number(id) == 19 && <td>{value.managerName}</td>}
                                                            <td>{DateFormat(value.Notification)}</td>
                                                            <td>
                                                                {
                                                                    value.hold_status == 'Entered' ?  
                                                                    <>
                                                                        <Tooltip title='Approve'><><i className="fa-solid fa-circle-check fa-lg me-1" id={`approve2${value.recordid}`} title="Approve" hidden={false} style={{color: 'green'}} onClick={()=>{approve(value.recordid, value.Id,document.getElementById(`approve2${value.recordid}`), document.getElementById(`load2${value.recordid}`))}}></i><i className="fa-solid fa-spinner fa-spin fa-lg me-1" id={`load2${value.recordid}`} hidden={true} style={{color: 'green'}}></i></></Tooltip>
                                                                        <Tooltip title='Decline'><ThumbDownAltIcon className='me-1' sx={{color: 'red'}} onClick={()=>{decline(value.recordid, value.Id)}} /></Tooltip>
                                                                        <Tooltip title="View Reason"><VisibilityIcon className='me-1' sx={{color: 'blue'}} data-bs-toggle="modal" data-bs-target={`#reason-view${value.recordid}`} /></Tooltip>
                                                                    </>
                                                                     : null
                                                                }
                                                            </td>
                                                        </tr>
                                                        <div className="modal fade" id={`reason-view${value.recordid}`} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                            <div className="modal-dialog modal-dialog-centered">
                                                                <div className="modal-content">
                                                                <div className="modal-header">
                                                                    <h5 className="modal-title" id="exampleModalLabel">Reason to Hold Reports : {value.Entity}</h5>
                                                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                                </div>
                                                                <div className="modal-body">
                                                                    <div className='fw-bold'>
                                                                    Reason:
                                                                    </div>
                                                                    <div>
                                                                    {value.hold_reason}
                                                                    </div>
                                                                </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </>
                                                )
                                            }
                                            else{
                                                return(
                                                    <>
                                                        <tr>
                                                            <td>{a++}</td>
                                                            <td>{value.Entity}</td>
                                                            <td>{DateFormat(value.Notification)}</td>
                                                            <td>
                                                                {
                                                                    value.hold_status == 'Entered' ? 'Requested' : value.hold_status == 'Approved' ? 'Approved' : 
                                                                    <button className='btn btn-primary btn-sm' data-bs-toggle="modal" data-bs-target={`#requestrr${value.recordid}`}>Request</button>
                                                                }
                                                            </td>
                                                        </tr>
                                                        <div className="modal fade" id={`requestrr${value.recordid}`} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                                <form className="modal-dialog modal-dialog-centered" 
                                                                    onSubmit={(event)=>{
                                                                        rrhold(event, 
                                                                            value.recordid,
                                                                            value.Id,
                                                                            document.getElementById(`checkRR${value.recordid}`).value,
                                                                            document.getElementById(`rrreasonid${value.recordid}`).value, 
                                                                            document.getElementById(`fromrrdate${value.recordid}`).value, 
                                                                            document.getElementById(`fromrrtime${value.recordid}`).value, 
                                                                            document.getElementById(`torrdate${value.recordid}`).value, 
                                                                            document.getElementById(`torrtime${value.recordid}`).value, 
                                                                            document.getElementById(`rrsubmit${value.recordid}`), 
                                                                            document.getElementById(`rrload${value.recordid}`), 
                                                                            document.getElementById(`rrbtn${value.recordid}`))
                                                                        }}
                                                                    >
                                                                    <div className="modal-content">
                                                                        <div className="modal-header">
                                                                            <div>
                                                                                <h5 className="modal-title" id="exampleModalLabel">{value.Entity}</h5>
                                                                            </div>
                                                                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                                        </div>
                                                                        <Box sx={{ width: '100%' }}>
                                                                            <Collapse in={open}>
                                                                                <Alert
                                                                                severity={alertType}
                                                                                action={
                                                                                    <IconButton
                                                                                    aria-label="close"
                                                                                    color="inherit"
                                                                                    size="small"
                                                                                    onClick={() => {
                                                                                        setOpen(false);
                                                                                    }}
                                                                                    >
                                                                                    <CloseIcon fontSize="inherit" />
                                                                                    </IconButton>
                                                                                }
                                                                                sx={{ mb: 2 }}
                                                                                >
                                                                                {message}
                                                                                </Alert>
                                                                            </Collapse>
                                                                        </Box>
                                                                        <div className="modal-body" style={{overflow:"scroll"}}>
                                                                            <div class="form-check">
                                                                                <input class="form-check-input" type="checkbox" value="RR" id={`checkRR${value.recordid}`} checked disabled />
                                                                                <label class="form-check-label" for="flexCheckIndeterminateDisabled">
                                                                                    Rating Report
                                                                                </label>
                                                                            </div>
                                                                            <div class="form-check">
                                                                                <input class="form-check-input" type="checkbox" value="PR" id="flexCheckDefault" onChange={(e)=>{
                                                                                    if(e.target.checked){
                                                                                        if(document.getElementById(`checkRR${value.recordid}`)){
                                                                                            document.getElementById(`checkRR${value.recordid}`).value = "RR,PR";
                                                                                            console.log(document.getElementById(`checkRR${value.recordid}`).value)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                    else{
                                                                                        if(document.getElementById(`checkRR${value.recordid}`)){
                                                                                            document.getElementById(`checkRR${value.recordid}`).value = "RR";
                                                                                            console.log(document.getElementById(`checkRR${value.recordid}`).value)
                                                                                        }
                                                                                    }
                                                                                }
                                                                                    } />
                                                                                <label class="form-check-label" for="flexCheckDefault">
                                                                                    Press Release
                                                                                </label>
                                                                            </div>
                                                                            <div className='fw-bold mt-2'>
                                                                                From:
                                                                            </div>
                                                                            <div>
                                                                                <div>
                                                                                    Date: <input className='form-control ms-2' type='date' id={`fromrrdate${value.recordid}`} required />
                                                                                    Time: <input className='form-control ms-2' type='time' id={`fromrrtime${value.recordid}`} required />
                                                                                </div>
                                                                            </div>
                                                                            <div className='fw-bold mt-2'>
                                                                                To:
                                                                            </div>
                                                                            <div>
                                                                                <div>
                                                                                    Date: <input className='form-control ms-2' type='date' id={`torrdate${value.recordid}`} required />
                                                                                    Time: <input className='form-control ms-2' type='time' id={`torrtime${value.recordid}`} required />
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                            <div className='fw-bold mt-2'>Reason:</div>
                                                                            <textarea className='form-control'  style={{height: "100%"}} id={`rrreasonid${value.recordid}`} required></textarea>
                                                                            </div>
                                                                        </div>
                                                                        <div className="modal-footer">
                                                                            <button type="button" className="btn btn-secondary" id={`rrholdclose${index}`} data-bs-dismiss="modal">Close</button>
                                                                            <button className="btn btn-primary" type='submit' id={`rrbtn${value.recordid}`}>
                                                                                <div id={`rrsubmit${value.recordid}`}>Submit</div>
                                                                                    <div id={`rrload${value.recordid}`} hidden={true}>
                                                                                    <i class='fa-solid fa-spinner fa-spin fa-lg'></i>
                                                                                </div>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </form>
                                                        </div>
                                                    </>
                                                )
                                            }

                                        })
                                    }
                                </tbody>
                            </table>
                </div>
              
              </> :
              <div className='fs-3 fw-bold text-center mt-5 mb-3' style={{color: "#000078"}}>
                  No rows to show!
              </div>
              :
              (<div className="mt-5 mx-auto" style={{ width: "fit-content" }}>
              <div class="wrapper" id="loader2">
                <svg
                  class="hourglass"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 120 206"
                  preserveAspectRatio="none"
                >
                  <path
                    class="middle"
                    d="M120 0H0v206h120V0zM77.1 133.2C87.5 140.9 92 145 92 152.6V178H28v-25.4c0-7.6 4.5-11.7 14.9-19.4 6-4.5 13-9.6 17.1-17 4.1 7.4 11.1 12.6 17.1 17zM60 89.7c-4.1-7.3-11.1-12.5-17.1-17C32.5 65.1 28 61 28 53.4V28h64v25.4c0 7.6-4.5 11.7-14.9 19.4-6 4.4-13 9.6-17.1 16.9z"
                  />
                  <path
                    class="outer"
                    d="M93.7 95.3c10.5-7.7 26.3-19.4 26.3-41.9V0H0v53.4c0 22.5 15.8 34.2 26.3 41.9 3 2.2 7.9 5.8 9 7.7-1.1 1.9-6 5.5-9 7.7C15.8 118.4 0 130.1 0 152.6V206h120v-53.4c0-22.5-15.8-34.2-26.3-41.9-3-2.2-7.9-5.8-9-7.7 1.1-2 6-5.5 9-7.7zM70.6 103c0 18 35.4 21.8 35.4 49.6V192H14v-39.4c0-27.9 35.4-31.6 35.4-49.6S14 81.2 14 53.4V14h92v39.4C106 81.2 70.6 85 70.6 103z"
                  />
                </svg>
              </div>
            </div>)
            }
    </div>
  )
}
